module.exports = __webpack_public_path__ + "img/u1659.0aeb237d.png";